<template>
    <div :class="$style.wrapper">
        <h1>收货地址管理</h1>
        <div :class="$style.section">
            <h2>现有收货地址</h2>
            <div>
                <div v-if="addressList.length<=0">暂无数据</div>
                <div
                    :class="$style.address"
                    v-for="({select,  address_id, address,  city_name, district_name, province_name, mobile, consignee}, index) in addressList"
                    :key="address_id"
                >
                    <span>{{`${index + 1}.${consignee},${province_name},${city_name},${district_name},${address},${mobile}`}}</span>
                    <AddressDialog
                        :type="1"
                        :editData="addressList[index]"
                        :getAddress="getAddress"
                    ><a>修改</a></AddressDialog>
                    <a>|</a>
                    <Confirm 
                        :placement="'top'" 
                        :handleConfirm="() => delAddress(address_id)"
                        :loading="btnLoading">
                            <a>删除</a>
                    </Confirm>
                    <el-button v-if="select===1" :class="$style.default">默认地址</el-button>
                    <el-button v-else type="text" :class="$style.setBtn" @click="setDefalut(address_id)">设为默认地址
                    </el-button>
                </div>
            </div>
        </div>
        <div :class="$style.section" style="border-top: 0">
            <h2>新增收货地址</h2>
            <div :class="$style.form">
                <el-form ref="form" :rules="rules" :model="formData" size="mini" label-width="100px">
                    <el-form-item label="姓名：" prop="consignee">
                        <el-input v-model="formData.consignee"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：" prop="mobile">
                        <el-input v-model="formData.mobile"></el-input>
                    </el-form-item>
                    <el-form-item class="address" label="地址：">
                        <el-select v-model="formData.province" placeholder="省份">
                            <el-option
                                v-for="{region_id, region_name} in provinceList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            >
                            </el-option>
                        </el-select>
                        <el-select v-model="formData.city" placeholder="城市">
                            <el-option
                                v-for="{region_id, region_name} in cityList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            ></el-option>
                        </el-select>
                        <el-select v-model="formData.district" placeholder="区">
                            <el-option
                                v-for="{region_id, region_name} in districtList"
                                :key="region_id"
                                :value="region_id"
                                :label="region_name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="address" label="详细地址：">
                        <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="formData.address"></el-input>
                    </el-form-item>
                    <el-form-item class="additional">
                        <el-button :class="$style.submitBtn" :loading="btnLoading" @click="handleSubmit">添加地址</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { getAddress, delAddress, getAddressSelect, changeAddress } from '../../stores/api';
    import Confirm from '../Common/Confirm.vue';
    import AddressDialog from '../Common/AddressDialog.vue';
    import { mapState } from 'vuex';

    Vue.component('Confirm', Confirm);
    Vue.component('AddressDialog', AddressDialog);
    export default {
        data () {
            return {
                btnLoading: false,
                addressList: [],
                districtList: [],
                cityList: [],
                formData: {
                    consignee: '',
                    mobile: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                },
                //form校验
                rules: {
                    consignee: [{required: true, message: '请输入名字', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入手机', trigger: 'blur'}],
                    address: [{required: true, message: '请输入地址', trigger: 'blur'}],
                }
            };
        },
        beforeMount () {
            this.getAddress();
        },
        methods: {
            setDefalut (id) {
                this.addressList.forEach(item => (item.select = 0));
                this.addressList.find(item => item.address_id === id).select = 1;
            },
            getAddress () {
                getAddress().then(res => {
                    console.log(res)
                    this.addressList = res.data.consignee_list;
                });
            },
            delAddress (id) {
                this.btnLoading = true;
                delAddress(id).then(() => {
                    this.getAddress();
                    this.btnLoading = false;
                });
            },
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            handleSubmit () {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        this.btnLoading = true;
                        changeAddress(this.formData).then(async () => {
                            await this.getAddress();
                            this.$notify.success({
                                title: '操作成功',
                                message: `添加地址成功`,
                            });
                        }).catch((err) => {
                            this.$notify.error({
                                title: '操作失败',
                                message: err.message,
                            });
                        }).then(() => {
                            this.btnLoading = false;
                            this.visible = false;
                            //添加完后清空信息
                            Object.assign(this.formData, {
                                consignee: '',
                                mobile: '',
                                address: ''
                            });
                        });
                    }
                });
            },
        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            provinceList (val) {
                this.formData.province = val[0].region_id;
            }
        },
        computed: {
            ...mapState(['provinceList']),

        }
    };
</script>

<style lang="less" module>
    @import 'common';

    .wrapper {
        & > h1 {
            font-size: 20px;
            color: #636975;
        }
        .form {
            height: 269Px !important;
            padding-top: 14px !important;
            padding-bottom: 14px !important;
            form {
                width: 400Px;
                input, textarea {
                    border-radius: 0;
                }
                :global {
                    .el-form-item {
                        margin-bottom: 15Px;
                        .el-select {
                            width: 95Px;
                        }
                    }

                }
                .submitBtn {
                    .submitBtn;
                }
            }
        }
        .section {
            padding-top: 25px;
            border-top: 1px solid #d8dde6;
            & > h2 {
                padding: 8px 14px;
                margin: 0;
                font-size: 14px;
                color: #636975;
                background: #f0f5fc;
                border: 1px solid #d8dde6;
            }
            & > div {
                height: 240Px;
                padding: 0 14px;
                border: 1px solid #d8dde6;
                border-top: 0;
                overflow: auto;
            }
            .address {
                & > span:nth-child(1) {
                    padding: 14px 0;
                    display: block;
                    font-size: 16px;
                    color: #1f2329;
                }
                a {
                    font-size: 14px;
                    color: #2795f5;
                    cursor: pointer;
                    &:hover {
                        color: #66b1ff;
                    }
                }
                .setBtn {
                    font-size: 12px;
                    color: #636975;
                    margin-left: 40px;
                    height: 23px;
                    padding: 0;
                }
                .default {
                    background: #ffffff;
                    border: 1px solid #f74845;
                    border-radius: 4px;
                    width: 66Px;
                    height: 23Px;
                    font-size: 12px;
                    color: #f74845;
                    padding: 0;
                    margin-left: 40px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserInfo/Address.vue